/* Google tag manager implementation */

import Settings from "./settings.service";
import Storage from "./storage.service";

import Helpers from "../helpers/shared.helper";
import Translation from "./translation.service";
// import Summaries from "./summaries.service";
import Plans from "./plans.service";
import Products from "./products.service";
import Numbers from "./numbers.service";

let initial = {
  language: Translation.getCurrentLanguage(),
  event: undefined,
  unique_user_id_session: "",
  registration_id: "",
};

var GTMService = {};

GTMService.dataLayer = [initial];

GTMService.init = function () {
  window.dataLayer = GTMService.dataLayer;

  // Google Tag Manager
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l !== "dataLayer" ? "&l=" + l : "";
    j.async = true;
    j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, "script", "dataLayer", Settings.gtm_container_id);
  // End Google Tag Manager
  GTMService.onload();
};

let properties = ["uid", "registration_type"];

GTMService.onload = () => {
  for (let indx in properties) {
    let prop = properties[indx];
    if (Storage.get(prop)) {
      GTMService.set_user_property(prop, Storage.get(prop));
    }
  }
};

GTMService.pushData = (data) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  }
};

GTMService.pageView = (data = {}) => {
  data["language"] = Translation.getCurrentLanguage();
  data["page_name"] = Storage.get("Page_name");
  data["registration_id"] = Storage.get("uid", true) + "";
  data["unique_user_id_session"] = Storage.get("session");
  data["event"] = "page_view";
  data["eventCategory"] = "";
  data["eventAction"] = "";
  data["eventLabel"] = "";
  data["eventValue"] = "";

  GTMService.pushData(data);
};

GTMService.method_Select = (event, selected) => {
  let data = {};
  data["language"] = Translation.getCurrentLanguage();
  data["page_name"] = Storage.get("Page_name");
  data["registration_id"] = Storage.get("uid", true) + "";
  data["unique_user_id_session"] = Storage.get("session");
  data["event"] = event;
  data["selected_option"] = selected;
  data["eventCategory"] = "";
  data["eventAction"] = "";
  data["eventLabel"] = "";
  data["eventValue"] = "";

  GTMService.pushData(data);
};
var user_properties = [
  "unique_user_id_session",
  "registration_id",
  "registration_type",
  "number_selected_flow",
  "plan_select_flow",
  "Promotion_type",
];

GTMService.set_page_title = (property, val) => {
  if (window.dataLayer) {
    GTMService.dimension(property, val);
  }
};

GTMService.set_user_property = (property, val) => {
  let data = {};
  if (window.dataLayer) {
    if (property === "uid") {
      if (!val) {
        data["unique_user_id_session"] = "";
        data["registration_id"] = "";
      } else {
        if (!window.localStorage.getItem("uid")) {
          data["unique_user_id_session"] = Storage.get("session");
          if (process.env.REACT_APP_REACT_ENV === "production") {
            data["registration_id"] = val + "";
          } else {
            data["registration_id"] = "testuser";
          }
        }
      }
    }
    if (property === "registration_type") {
      // GTMService.dimension("Registration_type_customer", val);
      data["registration_type_customer"] = Storage.get(
        "registration_type_flow",
        true
      );
    }
  }

  return data;
};

GTMService.page_view = () => {
  let data = {};
  data["event"] = "page_view";
  data["eventCategory"] = "";
  data["eventAction"] = "";
  data["eventLabel"] = "";
  data["eventValue"] = "";
  GTMService.pushData(data);
};
GTMService.action_on_payment_done = () => {
  let infos = JSON.parse(window.localStorage.getItem("GTMinfos"));
  window.localStorage.removeItem("GTMinfos");
  window.localStorage.removeItem("order_id");
  window.localStorage.removeItem("save_card");
  window.localStorage.removeItem("plan_type");

  let summary = Storage.get("summary");

  if (infos) {
    let data = {};

    data["language"] = Translation.getCurrentLanguage();
    data["page_name"] = Storage.get("Page_name");
    data["unique_user_id_session"] = Storage.get("session");
    let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));

    if (process.env.REACT_APP_REACT_ENV === "production") {
      data["registration_id"] = uid + "";
    } else {
      data["registration_id"] = "testuser";
    }
    data["registration_type_customer"] = Storage.get(
      "registration_type_flow",
      true
    );
    data["number_selected_customer"] = summary.vanity.UI_Name;

    if (infos["plan_type_gtm"] === "CUS") {
      data["custom_plan_customer"] = 1;
      data["predefined_plan_customer"] = "";
    } else {
      data["custom_plan_customer"] = "";
      data["predefined_plan_customer"] = 1;
    }

    data["save_cc_customer"] = infos["save_cc_customer"];
    data["cc_payment"] = infos["cc_payment"];

    if (infos["promo_code"]) {
      data["Promotion_type"] = infos["promo_code"].toUpperCase();
    }

    data["event"] = "page_view";
    data["eventCategory"] = "";
    data["eventAction"] = "";
    data["eventLabel"] = "";
    data["eventValue"] = "";

    data["transaction_id"] = infos["orderKeys"];
    data["transaction_value"] = infos["transaction_value"];
    data["transactionProducts"] = infos["transactionProducts"];

    GTMService.pushData(data);
  }
};

GTMService.set_user_status = (val) => {
  let status = val ? "logged in" : "not logged in";
  if (window.dataLayer) {
    let data = {};

    if (!val) {
      data = { ...GTMService.set_user_property("uid", 0) };
      for (let indx in user_properties) {
        let prop = user_properties[indx];
        if (window.localStorage.getItem(prop)) {
          data = { ...GTMService.set_user_property(prop, "") };
        }
      }
    } else {
      data = { ...GTMService.set_user_property("uid", Storage.get("uid")) };
    }
    data["customer_status"] = status;
    data["event"] = undefined;
    GTMService.pushData(data);
  }
};

if (
  window.localStorage.getItem("session") &&
  window.localStorage.getItem("device_id")
) {
  if (window.localStorage.getItem("uid")) {
    initial.customer_status = "logged in";
    let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
    // initial.uid = uid;
    initial["unique_user_id_session"] = Storage.get("session", true);
    if (process.env.REACT_APP_REACT_ENV === "production") {
      initial["registration_id"] = uid + "";
    } else {
      initial["registration_id"] = "testuser";
    }
  }
}

GTMService.dimension = function (dimension, dimensionVal) {
  let obj = {};
  obj[dimension] = dimensionVal;
  if (window.dataLayer !== undefined) {
    window.dataLayer.push(obj);
  }
  // Globals.track("dimension", obj);
};

GTMService.metrics = function (metrics, metricsVal) {
  let obj = {};
  obj[metrics] = metricsVal;
  if (window.dataLayer !== undefined) {
    window.dataLayer.push(obj);
  }
  // Globals.track("metric", obj);
};

GTMService.ecommerce = function (
  transaction_id,
  transaction_value,
  item_name,
  item_price,
  item_SKU
) {
  window.dataLayer = window.dataLayer || [];
  let obj = {
    transaction_id: transaction_id,
    transaction_value: transaction_value,
    transactionProducts: [
      {
        sku: item_SKU,
        name: item_name,
        category: "1",
        price: parseFloat(Helpers.formatNumber(item_price)),
        quantity: 1,
      },
    ],
  };
  if (window.dataLayer !== undefined) {
    window.dataLayer.push(obj);
  }
  // Globals.track("ecommerce", obj);
};

GTMService.event = function (
  event,
  eventCategory,
  eventAction,
  eventLabel = "",
  eventValue = ""
) {
  let obj = {
    event: event,
    eventCategory: eventCategory,
    eventAction: eventAction,
    language: Translation.getCurrentLanguage(),
    eventLabel: eventLabel ? eventLabel : "",
    eventValue: eventValue ? eventValue : "",
  };
  if (window.dataLayer !== undefined) {
    window.dataLayer.push(obj);
  }
  // Globals.track("event", obj);
};

GTMService.eventOb = function (
  page_name = "",
  event,
  eventCategory,
  eventAction,
  eventLabel = "",
  eventValue = ""
) {
  let obj = {
    event: event,
    eventCategory: eventCategory,
    eventAction: eventAction,
    language: Translation.getCurrentLanguage(),
    eventLabel: eventLabel ? eventLabel : "",
    eventValue: eventValue ? eventValue : "",
    page_name: page_name ? page_name : "",
    unique_user_id_session: Storage.get("session", true),
  };
  if (window.dataLayer !== undefined) {
    window.dataLayer.push(obj);
  }
  // Globals.track("event", obj);
};

GTMService.addPaymentInfoForGTM = (
  transaction_id,
  transaction_value,
  item_name,
  item_price,
  item_SKU
) => {
  GTMService.ecommerce(
    transaction_id,
    transaction_value,
    item_name,
    item_price,
    item_SKU
  );
};

GTMService.submit_address = () => {
  // GTMService.dimension("unique_user_id_session", Storage.get("session"));
  // GTMService.dimension("registration_id", Storage.get("session"));
};

GTMService.sim_on_the_way = () => {
  let data = {};
  data["language"] = Translation.getCurrentLanguage();
  data["page_name"] = Storage.get("Page_name");
  data["unique_user_id_session"] = Storage.get("session");
  let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }

  GTMService.pushData(data);
};

GTMService.action_on_search_click_on_cta = () => {
  GTMService.event(
    "search_for_number",
    "Booking",
    "Click on Search for number",
    "Search for number"
  );
};
GTMService.action_on_book_your_number_click_on_cta = () => {
  let data = {};
  data["event"] = "book_number";
  data["eventCategory"] = "Booking";
  data["eventAction"] = "Click onBook number";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = "Book number";
  data["eventValue"] = "";

  GTMService.pushData(data);
};
GTMService.action_on_pay_by_cc_delivery_click_on_cta = () => {
  let data = {};
  data["page_name"] = Storage.get("Page_name");
  data["delivery_method"] = "shipping";
  data["event"] = "click_pay_by_cc_delivery";
  data["eventCategory"] = "Checkout";
  data["eventAction"] = "Click on Get it now";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = "Get it now";
  data["eventValue"] = "";

  GTMService.pushData(data);
};

GTMService.action_on_pay_by_cc_pickup_click_on_cta = () => {
  let data = {};
  data["page_name"] = Storage.get("Page_name");
  data["delivery_method"] = "pickup in store";
  data["event"] = "click_pay_by_cc_pickup";
  data["eventCategory"] = "Checkout";
  data["eventAction"] = "Click on Pay by credit card";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = "Pay by credit card";
  data["eventValue"] = "";

  GTMService.pushData(data);
};

GTMService.ob_check_eligibility = (eligibilty_value) => {
  let data = {};
  data["page_name"] = Storage.get("Page_name");
  data["event"] = eligibilty_value;
  data["eventCategory"] = "check eligibility";
  data["eventAction"] = "check eligibility on load";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = eligibilty_value;
  data["eventValue"] = "";
  data["unique_user_id_session"] = Storage.get("session");
  let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }
  GTMService.pushData(data);
};

GTMService.ob_sim_selection = (sim_selected_option) => {
  let data = {};
  const selectedPlanInfo = JSON.parse(
    Storage.get("selectedProductDetailsGTM", true)
  );
  let plan_type = Storage.get("plan_type", true);
  let specs = Storage.get("specs", true);
  let commitment = selectedPlanInfo?.commitment;
  let plan_price = selectedPlanInfo?.discountedPrice;
  let sku_name = plan_type + " " + commitment + "|" + specs;
  data["page_name"] = Storage.get("Page_name");
  data["delivery_method"] = "pickup in store";
  data["unique_user_id_session"] = Storage.get("session");
  let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }
  data["registration_type_customer"] = Storage.get(
    "registration_type_flow",
    true
  );
  data["event"] = "Click on" + sim_selected_option;
  data["eventCategory"] = "Checkout";
  data["eventAction"] = "Click on" + sim_selected_option;
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = sim_selected_option;
  data["eventValue"] = "";
  data["transaction_id"] = sim_selected_option + "_" + uid;
  data["transaction_value"] = plan_price;

  data["transactionProducts"] = [
    {
      sku: sku_name,
      name: sku_name,
      category: "1",
      quantity: 1,
    },
  ];

  GTMService.pushData(data);
};
GTMService.action_gtm_on_payment_done = () => {
  let data = {};
  const selectedPlanInfo = JSON.parse(
    Storage.get("selectedProductDetailsGTM", true)
  );
  let plan_type = Storage.get("plan_type", true);
  let specs = Storage.get("specs", true);
  let commitment = selectedPlanInfo?.commitment;
  let plan_price = selectedPlanInfo?.discountedPrice;
  let plan_name = selectedPlanInfo?.name;
  let sku_name = plan_type + " " + commitment + "|" + specs;
  data["page_name"] = "Payment confirmation";
  data["unique_user_id_session"] = Storage.get("session");
  let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }
  data["registration_type_customer"] = Storage.get(
    "registration_type_flow",
    true
  );
  data["event"] = "on Payment done successfully";
  data["eventCategory"] = "payment";
  data["eventAction"] = "After payment done";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = "payment success";
  data["eventValue"] = "payment done";
  data["transaction_id"] = "payment success_" + uid;
  data["transaction_value"] = plan_price;

  data["transactionProducts"] = [
    {
      sku: sku_name,
      name: plan_name,
      price: Storage.get("paymentPrice", true),
      category: "1",
      quantity: 1,
    },
  ];

  Storage.clear("selectedProductDetailsGTM");
  Storage.clear("specs");
  Storage.clear("gtm-number-detail");
  Storage.clear("order_id");

  GTMService.pushData(data);
};

GTMService.pay_in_store_pickup = false;
GTMService.action_on_pay_in_store_pickup_click_on_cta = () => {
  Storage.get_obsrv("summary").subscribe((summary) => {
    if (
      summary &&
      summary.prices &&
      summary.selected_bundle &&
      summary.vanity
    ) {
      if (!GTMService.pay_in_store_pickup) {
        GTMService.pay_in_store_pickup = true;

        let data = {};
        let plan_type = summary.selected_bundle["bundle_type"];
        let transaction_value = summary.prices.plan;

        let vat_percentage =
          parseFloat(summary.prices.vat_percentage, 10) / 100;
        let item_price = transaction_value * (1.0 + vat_percentage);
        item_price = parseFloat(Helpers.formatNumber(item_price));

        let specs = Plans.getPlanIDs(summary.selected_bundle, true);
        let commitment = Products.getCurrentProductCommitment();
        let sku_name = plan_type + " " + commitment + "|" + specs;

        data["page_name"] = Storage.get("Page_name");
        data["delivery_method"] = "pickup in store";
        data["unique_user_id_session"] = Storage.get("session");
        let uid = JSON.parse(
          JSON.stringify(window.localStorage.getItem("uid"))
        );
        if (process.env.REACT_APP_REACT_ENV === "production") {
          data["registration_id"] = uid + "";
        } else {
          data["registration_id"] = "testuser";
        }
        data["registration_type_customer"] = Storage.get(
          "registration_type_flow",
          true
        );
        data["number_selected_customer"] = summary.vanity.UI_Name;
        data["event"] = "click_pay_in_store_pickup";
        data["eventCategory"] = "Checkout";
        data["eventAction"] = "Click on Pickup in store";
        data["language"] = Translation.getCurrentLanguage();
        data["eventLabel"] = "Pickup in store";
        data["eventValue"] = "";

        if (plan_type === "CUS") {
          data["custom_plan_customer"] = 1;
          data["predefined_plan_customer"] = "";
        } else {
          data["custom_plan_customer"] = "";
          data["predefined_plan_customer"] = 1;
        }

        data["transaction_id"] = "pay_in_store_" + Storage.get("uid", true);
        data["transaction_value"] = transaction_value;

        // data['item_name']= sku_name;
        // data['item_category']= "1";
        // data['item_price']= parseFloat(Helpers.formatNumber(item_price));
        // data['item_quantity']= 1;

        data["transactionProducts"] = [
          {
            sku: sku_name,
            name: sku_name,
            price: parseFloat(Helpers.formatNumber(item_price)),
            category: "1",
            quantity: 1,
          },
        ];

        GTMService.pushData(data);
      }
    }
  });
};

GTMService.action_on_click_on_cta_yes = () => {
  GTMService.event("Click on CTA - YES", "TDB", "Your email - yes");
};

GTMService.action_on_click_on_cta_no = () => {
  GTMService.event("Click on CTA - NO", "TDB", "Your email - no");
};

GTMService.action_on_registration_type_email = () => {
  // GTMService.dimension("registration_type_flow", "Email");
  Storage.set("registration_type_flow", "Email", true);
  // window.localStorage.setItem("GTMinfos", JSON.stringify(GTMinfos));
  // GTMService.metrics("Email subscription (Yes-button)", 1);
};

GTMService.action_on_plan_click_on_cta = () => {
  GTMService.event("Click on CTA", "TDB", "Plan - continue");
};

GTMService.action_on_sms_link_requested = () => {
  GTMService.event("SMS link requested", "TDB", "SMS link requested");
};

GTMService.action_on_payment_failed = () => {
  let data = {};

  data["event"] = "payment_failure";
  data["eventCategory"] = "Checkout";
  data["eventAction"] = "Payment failure";
  data["language"] = Translation.getCurrentLanguage();
  data["eventLabel"] = "Payment failure";
  data["eventValue"] = "";

  data["unique_user_id_session"] = Storage.get("session");
  let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
  if (process.env.REACT_APP_REACT_ENV === "production") {
    data["registration_id"] = uid + "";
  } else {
    data["registration_id"] = "testuser";
  }

  GTMService.pushData(data);
};

GTMService.general_error = (error) => {
  GTMService.metrics("Error_messages_tech", 1);
  if (error && error.response && error.response.data) {
    GTMService.dimension("Error_messages_tech", error.response.data.error);
  } else {
    GTMService.dimension("Error_messages_tech", error);
  }
  // (event, eventCategory, eventAction, eventLabel, eventValue)
  GTMService.event("error", "http", "error", "error", "General http error");
};

GTMService.action_on_facebook_button_click = () => {
  GTMService.event("facebook_link", "Account", "Click on Facebook", "Facebook");
};

GTMService.action_on_click_on_use_email = () => {
  GTMService.event("Click on Use Email", "TDB", "Use email");
};

GTMService.action_on_google_button_click = () => {
  GTMService.event("googleplus_link", "Account", "Click on Google+", "Google+");
};
GTMService.action_on_twitter_button_click = () => {
  GTMService.event("twitter_link", "Account", "Click on twitter", "Twitter");
};

GTMService.action_on_vm_app_link = () => {
  GTMService.event("Click on VM app link", "TDB", "VM App link");
};

GTMService.action_on_number_click_on_cta = (type) => {
  if (type === "random") {
    GTMService.event("Click on CTA", "TDB", "Random number - CTA clicked");
  }
};

GTMService.action_on_checkout_cta_clicked = () => {
  GTMService.event("Checkout - CTA clicked", "TDB", "Checkout - CTA clicked");
};

GTMService.action_on_address_manual_search = () => {
  GTMService.event(
    "Address_search",
    "Address",
    "Manual address search initiated"
  );
};

GTMService.action_on_plans_click_on_customize = () => {
  GTMService.event(
    "customize_plan",
    "Booking",
    "Click on Customize Plan",
    "Customize Plan"
  );
};

GTMService.action_on_promo_popup_closed = () => {
  GTMService.event("Promo_popup_closed", "Promo", "Promo popup closed");
};

GTMService.action_on_promo_popup_opened = () => {
  GTMService.event("Promo_popup_opened", "Promo", "Promo popup opened");
};

GTMService.action_on_checkout_collapsed = () => {
  GTMService.event("Checkout_collapsed", "Payment", "Checkout collapsed");
};

GTMService.action_on_checkout_expanded = () => {
  GTMService.event("Checkout_expanded", "Payment", "Checkout expanded");
};

GTMService.action_on_payment_success = () => {
  GTMService.event(
    "Payment_successful",
    "Payment",
    "Payment successful",
    "Success"
  );
};

GTMService.action_on_promo_redeemed = (type, value) => {
  GTMService.event("Promo_redeemed", "Promo", "Promo redeemed", type, value);
};

GTMService.action_on_legal_stuff_link = () => {
  GTMService.event(
    "legal_stuff_link",
    "Account",
    "Click on Legal stuff",
    "Legal stuff"
  );
};

GTMService.action_on_choose_payment_method = (selected_method) => {
  GTMService.event(
    "Payment option",
    "select payment option",
    "Click on continue payment",
    selected_method
  );
};
GTMService.action_on_summary_legal_stuff_link = () => {
  GTMService.event(
    "legal_stuff_link",
    "payment Summary",
    "Click on Legal stuff checkbox",
    "Legal stuff"
  );
};
GTMService.action_on_get_the_app_link = () => {
  GTMService.event(
    "get_the_app_link",
    "Account",
    "Click on get the app",
    "Get the app"
  );
};

GTMService.set_registration_type = (type) => {
  // GTMService.dimension("registration_type_flow", type);
  Storage.set("registration_type_flow", type, true);
};

GTMService.set_data_for_number_selected = (vanityId, vanityName) => {
  //Number_selected_flow values ==> Free, Rare, Legendary, Exotic
  GTMService.dimension("number_selected_flow", vanityName);

  //Number_selected_flow_vanity_id values ==> 1, 2, 3, 4
  GTMService.dimension("number_selected_flow_vanity_id", vanityId);
};

GTMService.set_data_for_plan_selected = (data) => {
  let info = {};
  // info['plan_select_flow']=data;
  info["event"] = "get_this_plan";
  info["eventCategory"] = "Booking";
  info["eventAction"] = "Click on Get this plan";
  info["language"] = Translation.getCurrentLanguage();
  info["eventLabel"] = "Get this plan";
  info["eventValue"] = "";
  GTMService.pushData(info);
};

GTMService.GTMObjfromStorage = (step) => {
  let actionField = "";
  let module = "";
  let event = "checkout";
  let object_Name = "checkout";

  let selected_module = null;
  let gtm_object = {};
  let GTM_Obj = JSON.parse(Storage.get("GTM_Obj", true))
    ? JSON.parse(Storage.get("GTM_Obj", true))
    : Storage.get("saved_plans", true)[0].Plans;
  let GTMinfos = JSON.parse(Storage.get("GTMinfos", true));

  switch (Storage.get("sim_activation_type", true)) {
    case "deliver_sim":
      module = "deliverd";
      break;
    case "has_sim":
      module = "Sim";
      break;
    case "has_esim":
      module = "eSim";
      break;

    default:
      break;
  }

  switch (step) {
    case "eligibility_check":
      actionField = {
        step: 1,
        option: "Eligible Checked",
      };
      break;

    case "account_created":
      actionField = {
        step: 2,
        option: "Account Created",
      };
      break;

    case "absher_verfication":
      actionField = {
        step: 3,
        option: "Absher Verification",
      };
      break;

    case "activation_type_selected":
      selected_module = module;
      actionField = {
        step: 4,
        option: "Activation Type Selected",
      };
      break;

    case "card_details_filled":
      selected_module = module;
      actionField = {
        step: 5,
        option: "Card Details Filled",
      };
      break;

    case "checkout_complete":
      selected_module = module;
      event = "checkout_complete";
      object_Name = "purchase";
      actionField = {
        id: GTMinfos.orderKeys, // Transaction ID. Required for purchases and refunds.
        affiliation: "Online Store",
        revenue: GTMinfos.transactionProducts[0].price, // Total transaction value (incl. tax and shipping)
        tax: GTMinfos.transactionProducts[0].price - GTMinfos.transaction_value,
        shipping: null,
      };
      Storage.clear("sim_activation_type");
      break;

    default:
      break;
  }

  gtm_object = {
    event: event,
    ecommerce: {
      currencyCode: "SAR",
      [object_Name]: {
        actionField: actionField,
        products: [
          {
            name: GTM_Obj.name, // Plan Name
            id: GTM_Obj.id, // Id of Plan Selected.
            price: GTM_Obj.price, // Total Price.
            brand: "Virgin Mobile", // Product Brand Name.
            category: "1 month", // Plan Category(1 month/6month /12months).
            variant: GTM_Obj.variant, // Plan Details (Datapack|Minutes)
            quantity: 1, // Quantity
            dimension14: GTM_Obj.dimension14, // Number Price.
            dimension15: GTM_Obj.dimension15, // Number Price Category
            dimension16: GTM_Obj.dimension16, // Plan Price
            dimension17: GTM_Obj.dimension17, // DataPack in Plan
            dimension18: GTM_Obj.dimension18, // Minutes in Plan
            dimension19: GTM_Obj.dimension19, // Plan Additional Offer
            dimension20: selected_module, // Payment Option Selected
            metric7: GTM_Obj.metric7, // Number Price
            metric8: GTM_Obj.metric8, // Plan Price
            metric9: GTM_Obj.metric9, //Number price VAT
            metric10: GTM_Obj.metric10, //Plan Price VAT
          },
        ],
      },
    },
  };
  return gtm_object;
};

GTMService.set_data_for_add_to_cart = (name, plan, promo, planPrice) => {
  let reservedNumber = Storage.get("reserved_number");
  let VanityLevel = Numbers.getVanityLevelID(reservedNumber);
  let summary = Storage.get("summary");
  let vatPercentage =
    JSON.parse(Storage.get("business", true)).vat_percentage / 100;

  const storagePricingItem = Storage.pricing[
    plan["DATA"].ID + "," + plan["VOICE-LCL"].ID
  ]
    ? Storage.pricing[plan["DATA"].ID + "," + plan["VOICE-LCL"].ID]
    : Storage.pricing[plan["VOICE-LCL"].ID + "," + plan["DATA"].ID];

  let promotions = promo
    ? promo
    : storagePricingItem.Promotions
      ? storagePricingItem.Promotions
      : null;

  if (promotions && promotions.length) {
    let min = 0,
      data = 0;
    for (let i = 0; i < promotions.length; i++) {
      if (promotions[i].Type === "FreePlan") {
        let promo = JSON.parse(promotions[i].Value);
        if (promo.Type === "DATA-SOCIAL" || promo.Type === "DATA") {
          data =
            promo.Value === -1 ? "Unlimited" : Helpers.bytesToGBs(promo.Value);
        } else if (
          promo.Type === "VOICE-LCL" ||
          promo.Type === "VOICE-ON-NET"
        ) {
          min = min + Helpers.milisecondstoMinutes(promo.Value);
        }
      }
    }
    promotions = min + "|" + data;
  } else {
    promotions = "0|0";
  }

  let obj = {};
  if (window.localStorage.getItem("uid")) {
    obj.customer_status = "logged in";
    let uid = JSON.parse(JSON.stringify(window.localStorage.getItem("uid")));
    obj["unique_user_id_session"] = Storage.get("session", true);
    if (process.env.REACT_APP_REACT_ENV === "production") {
      obj["registration_id"] = uid + "";
    } else {
      obj["registration_id"] = "testuser";
    }
  }
  obj["event"] = "add_to_cart";
  obj["ecommerce"] = {
    currencyCode: "SAR",
    add: {
      // 'add' actionFieldObject measures.
      products: [
        {
          name: name, // Plan Name
          id: plan["VOICE-LCL"].ID + "," + plan["DATA"].ID, // Id of Plan Selected.
          price: planPrice
            ? summary.prices.number + planPrice
            : summary.prices.number + storagePricingItem.Price, // Total Price.
          brand: "Virgin Mobile", // Product Brand Name.
          category: "1 month", // Plan Category(1 month/6month/12months).
          variant: plan["VOICE-LCL"].Formatted + "|" + plan["DATA"].Formatted, // Plan Details (Datapack|Minutes)
          quantity: 1, // Quantity
          dimension14: reservedNumber.Price, // Number Price.
          dimension15:
            Storage.get("vanity_details")[VanityLevel]["Vanity_Name"], // Number Price Category
          dimension16: planPrice ? planPrice : storagePricingItem.Price, // Plan Price
          dimension17: plan["DATA"].Formatted, // DataPack in Plan
          dimension18: plan["VOICE-LCL"].Formatted, // Minutes in Plan
          dimension19: promotions, // Plan Additional Offer
          metric7: reservedNumber.Price, // Number Price
          metric8: planPrice ? planPrice : storagePricingItem.Price, // Plan Price
          metric9: reservedNumber.Price * vatPercentage, //Number price VAT
          metric10: planPrice
            ? planPrice * vatPercentage
            : storagePricingItem.Price * vatPercentage, //Plan Price VAT
        },
      ],
    },
  };
  Storage.set("GTM_Obj", JSON.stringify(obj.ecommerce.add.products[0]), true);
  GTMService.pushData(obj);
};

GTMService.set_data_for_add_to_cart_kuwait = (
  name,
  selectedPlanInfo,
  plan,
  promo
) => {
  let obj = {};
  let id = {};
  const plan_type = Storage.get("plan_type", true);
  if (plan_type === "CUS") {
    id = plan["VOICE-LCL"].planId + "," + plan["DATA"].planId;
  } else {
    id = plan["VOICE-LCL"].ID + "," + plan["DATA"].ID;
  }
  obj["unique_user_id_session"] = Storage.get("session", true);
  obj["event"] = "add_to_cart";
  obj["ecommerce"] = {
    currencyCode: "KD",
    add: {
      products: [
        {
          name: name + "- " + selectedPlanInfo?.name,
          brand: "Virgin Mobile", // Product Brand Name.
          id,
          price: selectedPlanInfo?.discountedPrice,
          plan: plan,
          promotions: promo,
          commitment: selectedPlanInfo?.commitment,
        },
      ],
    },
  };

  GTMService.pushData(obj);
};

GTMService.coming_from_home = () => {
  let reservedNumber = Storage.get("reserved_number");
  let VanityLevel = Numbers.getVanityLevelID(reservedNumber);
  let summary = Storage.get("summary");
  let plan = Storage.get("selected_bundle").Plans;
  let vatPercentage =
    JSON.parse(Storage.get("business", true)).vat_percentage / 100;
  const planMinutes = plan.filter(
    (planItem) => planItem.Type === "VOICE-LCL"
  )[0];
  const planData = plan.filter((planItem) => planItem.Type === "DATA")[0];

  const planPricing = Storage.pricing[planData.ID + "," + planMinutes.ID]
    ? Storage.pricing[planData.ID + "," + planMinutes.ID]
    : Storage.pricing[planMinutes.ID + "," + planData.ID];
  let promotions = planPricing ? planPricing.Promotions : null;

  if (promotions && promotions.length) {
    let min = 0,
      data = 0;
    for (let i = 0; i < promotions.length; i++) {
      if (promotions[i].Type === "FreePlan") {
        let promo = JSON.parse(promotions[i].Value);
        if (promo.Type === "DATA-SOCIAL" || promo.Type === "DATA") {
          data =
            promo.Value === -1 ? "Unlimited" : Helpers.bytesToGBs(promo.Value);
        } else if (
          promo.Type === "VOICE-LCL" ||
          promo.Type === "VOICE-ON-NET"
        ) {
          min = Helpers.milisecondstoMinutes(promo.Value);
        }
      }
    }
    promotions = min + "|" + data;
  } else {
    promotions = "0|0";
  }

  let obj = {
    name:
      Storage.get("plan_type", true) +
      " 1|" +
      planMinutes.Formatted +
      "|" +
      planData.Formatted, // Plan Name
    id: planMinutes.ID + "," + planData.ID, // Id of Plan Selected.
    price: summary.prices.number + planPricing.Price, // Total Price.
    brand: "Virgin Mobile", // Product Brand Name.
    category: "1 month", // Plan Category(1 month/6month/12months).
    variant: planMinutes.Formatted + "|" + planData.Formatted, // Plan Details (Datapack|Minutes)
    quantity: 1, // Quantity
    dimension14: reservedNumber.Price, // Number Price.
    dimension15: Storage.get("vanity_details")[VanityLevel]["Vanity_Name"], // Number Price Category
    dimension16: planPricing.Price, // Plan Price
    dimension17: planData.Formatted, // DataPack in Plan
    dimension18: planMinutes.Formatted, // Minutes in Plan
    dimension19: promotions, // Plan Additional Offer
    metric7: reservedNumber.Price, // Number Price
    metric8: planPricing.Price, // Plan Price
    metric9: reservedNumber.Price * vatPercentage, //Number price VAT
    metric10: planPricing.Price * vatPercentage, //Plan Price VAT
  };
  Storage.set("GTM_Obj", JSON.stringify(obj), true);
};

GTMService.set_data_for_eligibility_check = () => {
  if (!Storage.get("GTM_Obj", true)) {
    GTMService.coming_from_home();
  }
  let obj = {};
  obj = GTMService.GTMObjfromStorage("eligibility_check");
  GTMService.pushData(obj);
};

GTMService.set_data_for_account_created = () => {
  let obj = {};
  obj = GTMService.GTMObjfromStorage("account_created");
  GTMService.pushData(obj);
};

GTMService.set_data_for_absher_verfication = () => {
  let obj = {};
  obj = GTMService.GTMObjfromStorage("absher_verfication");
  GTMService.pushData(obj);
};

GTMService.set_data_for_activation_type_selected = () => {
  let obj = {};
  obj = GTMService.GTMObjfromStorage("activation_type_selected");
  Storage.set(
    "GTM_Obj",
    JSON.stringify(obj.ecommerce.checkout.products[0]),
    true
  );
  GTMService.pushData(obj);
};

GTMService.set_data_for_card_details_filled = () => {
  let obj = {};
  obj = GTMService.GTMObjfromStorage("card_details_filled");
  GTMService.pushData(obj);
};

GTMService.set_data_for_checkout_complete = () => {
  let obj = {};
  obj = GTMService.GTMObjfromStorage("checkout_complete");
  GTMService.pushData(obj);
};

export default GTMService;
